import React from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { TextField, FormControl, FormHelperText } from '@mui/material';
import { styled } from '@mui/material/styles';

// Custom styled wrapper to integrate with MUI theme
const StyledPhoneInputWrapper = styled('div')(({ theme, error }) => ({
  '& .PhoneInput': {
    display: 'flex',
    alignItems: 'center',
  },
  '& .PhoneInputCountrySelect': {
    marginRight: theme.spacing(1),
    border: `1px solid ${error ? theme.palette.error.main : theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    fontSize: '0.875rem',
    minWidth: '80px',
    '&:focus': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: '2px',
    },
  },
  '& .PhoneInputInput': {
    flex: 1,
    border: 'none',
    outline: 'none',
    fontSize: '1rem',
    padding: 0,
    backgroundColor: 'transparent',
  },
}));

const CustomTextField = React.forwardRef((props, ref) => {
  const { onChange, value, error, helperText, ...otherProps } = props;

  return (
    <TextField
      {...otherProps}
      inputRef={ref}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      error={error}
      variant="outlined"
      fullWidth
    />
  );
});

CustomTextField.displayName = 'CustomTextField';

const PhoneNumberInput = ({
  value,
  onChange,
  error,
  helperText,
  label = "Phone Number",
  required = false,
  ...props
}) => {
  return (
    <FormControl fullWidth error={error}>
      <StyledPhoneInputWrapper error={error}>
        <PhoneInput
          international
          countryCallingCodeEditable={false}
          defaultCountry="US"
          value={value}
          onChange={onChange}
          inputComponent={CustomTextField}
          numberInputProps={{
            label,
            required,
            error,
            ...props
          }}
        />
      </StyledPhoneInputWrapper>
      {helperText && (
        <FormHelperText>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default PhoneNumberInput;
